import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";
import { handleErrors } from "./handleErrors";

export const authorize = (credentials) => {
  return axiosInstance.post(API_PATHS.AUTHORIZE, credentials);
};

export const getUser = async () => {
  return axiosInstance.get(API_PATHS.USER).catch(handleErrors);
};

export async function loginWithAuthorizationCode(code) {
  return axiosInstance.post(API_PATHS.AUTHORIZE_WITH_CODE, { code });
}

export const authorizeGoogle = (tokens) => {
  return axiosInstance.post(API_PATHS.AUTHORIZE_GOOGLE, tokens);
};

export const authorizeMicrosoft = (tokens) => {
  return axiosInstance.post(API_PATHS.AUTHORIZE_MICROSOFT, tokens);
};
